


































import { BLACK, WHITE } from '@oth/board'
import Disc from './Disc'
import Button from './Button'
import Select from './Select'
import SelectItem from './SelectItem'
import i18n from '../i18n'
import { get_prefs, set_prefs } from '../prefs'

defaults =
  user: BLACK
  level: 'normal'
  guide: true
  show_moves: false

export default
  data: -> {
    levels: ['easiest', 'easy', 'normal', 'hard', 'hardest']
    prefs: {defaults..., get_prefs()...}
    BLACK
    WHITE
    i18n
  }
  methods:
    submit: ->
      set_prefs @prefs
      {user, level, guide, show_moves} = @prefs
      @$emit 'start', {user, level, guide, show_moves}
  components: { Disc, Button, Select, SelectItem }
